import React from 'react';
import Iconify from '../Iconify';
import { IconProps } from 'src/@types/icon';

const IconifyIcon: React.FC<IconProps> = ({ icon, sx, ...otherProps }) => (
  <Iconify icon={icon} sx={sx} {...otherProps} />
);

export default IconifyIcon;
